import { render } from "./ClosedTaskCard.vue?vue&type=template&id=958da4e0&scoped=true"
import script from "./ClosedTaskCard.vue?vue&type=script&lang=js"
export * from "./ClosedTaskCard.vue?vue&type=script&lang=js"

import "./ClosedTaskCard.vue?vue&type=style&index=0&id=958da4e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958da4e0"]])

export default __exports__